import { render, staticRenderFns } from "./ContactsError.vue?vue&type=template&id=af2c2c10"
import script from "./ContactsError.vue?vue&type=script&lang=js"
export * from "./ContactsError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports